import React from 'react';
import { Button, Popconfirm, Icon, message, Divider } from 'antd';
import { Link } from 'react-router-dom';
import { observable, toJS, runInAction } from 'mobx';
import { observer } from 'mobx-react';
import {withRouter} from 'react-router'

import board_cast from '@common/BoardCast';

import ListTable from '@components/ListTable/ListTable.jsx';
import my_rake_back_store, { pagination_store, filter_store } from '@store/Statistic/MyRakeBack/MyRakeBackStore';
import OrderDetailModal from '@ViewsDashboard/User/UserList/Order/OrderDetailModal';

import breadcrumb_store from '@src/Store/Common/MyBreadcrumb';

@withRouter
@observer
class MyRakeBackListTable extends React.Component {
  constructor(props)
  {
    super();

  }

  componentWillReceiveProps(nextProps){

  }


  columns = [
    {
      key: 'pet_name',
      sorter: true,
      title: '投注人',
      dataIndex: 'pet_name'
    },
    {
      key: 'build_time',
      sorter: true,
      title: '投注时间',
      dataIndex: 'build_time',
      defaultSortOrder: 'descend'
    },
    {
      key: 'out_amount',
      sorter: true,
      title: '方案总金额',
      render(text, record, index) {
        return (
          <span>
            {window.FormatAmount(record.out_amount)}
          </span>
        )
      }
    },
    {
      key: 'yon_money',
      sorter: true,
      title: '我的返佣',
      render(text, record, index) {
        return (
          <span>
            {window.FormatAmount(record.yon_money)}（{record.get_radio}）
          </span>
        )
      }
    },
    {
      key: 'status',
      sorter: true,
      title: '状态',
      dataIndex: 'status',
    },
    {
      key: 'win_money',
      sorter: true,
      title: '派彩（彩金）',
      className: 'column-money',
      render(text, record, index) {
        return (
          <span>
            {window.FormatAmount(record.win_money)}（{window.FormatAmount(record.mosaic_win_money)}）
          </span>
        )
      }
    },
    {
      key: 'order_id',
      sorter: true,
      title: '订单ID',
      dataIndex: 'order_id',
    }
  ];

  componentWillMount(){
    this.closeAllExpanded()
  }


  componentDidMount() {
    my_rake_back_store.reloadDatas();
    board_cast.on('closeAllExpanded', this.closeAllExpandedForReload);
  }

  componentWillUnmount() {
    this.closeAllExpanded()
    filter_store.resetAttr();
  }

  //点击搜索回调
  closeAllExpandedForReload = () => {
    this.closeAllExpanded()
  }

  closeAllExpanded = () => {
    this.setState({
      expandedRowKeys: []
    });
  }

  expandedRowRender = (record, index, indent, expanded) => {

    //请求当前order数据
    // orderDetailStore.getOrderDetail(record.order_id);

    // console.log("ggg",JSON.stringify(record)+'  '+index+'  '+expanded);
    // console.log("ggg",index+'  '+expanded);
    // console.log("ggg",this.state.expandedRowKeys);

    // //防止重复加载没必要的数据
    if (this.state.expandedRowKeys.length == 0 ||
      this.state.expandedRowKeys.indexOf(record.order_id) == -1)
    {
      return (<div></div>);
    }

    return (
      <OrderDetailModal
        orderId={record.order_id}
        expanded={expanded}
      />
    )
  };

  /**
   * 分页器点击回调
   * @param {number} page
   * @param {number} size
   */
  pagination_callback(page, size, order_by) {
    my_rake_back_store.searchByFilter({
      page: page,
      page_size: size,
      ...order_by,
    })
  }

  render() {

    return (
      <ListTable
        data_source={toJS(my_rake_back_store.item_array)}
        columns={this.columns}
        rowClassName='cursor_pointer_all'
        pagination={
          {
            // 当前页
            current: pagination_store.page_cur,
            // 每页条数
            pageSize: pagination_store.page_size,
            // 总数据条数
            total: pagination_store.data_total,
            // 页码候选列表
            pageSizeOptions: pagination_store.page_size_options,
          }
        }
        expandedRowKeys={
          this.state.expandedRowKeys
        }
        expandedRowRender={
          this.expandedRowRender
        }
        onChange={
          (pagination, filters, sorter) => {
            let current = pagination.current;
            let page_size = pagination.pageSize;

            let order_by = undefined;
            if (sorter.columnKey !== undefined) {
              let desc = 0;
              if (sorter.order == 'descend') {
                desc = 1;
              }
              order_by = {
                order: sorter.columnKey,
                desc: desc
              }
            }

            this.pagination_callback(current, page_size, order_by);
          }
        }
        onExpand={(expanded, record) => {

          //这里请求会导致界面显示异常
          //请求当前order数据
          // orderDetailStore.getOrderDetail(record.order_id);
        }
        }
        onExpandedRowsChange={(expandedRows)=>{

          if (expandedRows.length < 2)
          {
            this.setState({
              expandedRowKeys: expandedRows
            });
          }
          else
          {
            this.setState({
              expandedRowKeys: [expandedRows[expandedRows.length -1]]
            });
          }
        }}
        expandRowByClick
      />
    )
  }
}

export default MyRakeBackListTable;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/Statistic/MyRakeBack/MyRakeBackListTable.jsx